import { render, staticRenderFns } from "./HeatmapRegistrationStep2.vue?vue&type=template&id=2d912b0a&scoped=true"
import script from "./HeatmapRegistrationStep2.vue?vue&type=script&lang=js"
export * from "./HeatmapRegistrationStep2.vue?vue&type=script&lang=js"
import style0 from "./HeatmapRegistrationStep2.vue?vue&type=style&index=0&id=2d912b0a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d912b0a",
  null
  
)

export default component.exports